import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";


export default class CustomersLogs extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers_Logs._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		props.parent ? this.request = "GET" : null;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		if (this.props.parent)
		{
			columns = [
				{
					Header: "Date Changed",
					className: 'center-column',
					id: "modified",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => {
						return obj.modified ? moment(obj.modified).local().local()
							.format("MM/DD/YYYY hh:mm A") : '-'
					}
				},
				{
					Header: "User",
					id: "modifier",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => obj.modifier || 'Account Owner'
				},
				{
					Header: "Field Changed",
					id: "field_changed",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.field_changed)
				},
				{
					Header: "Original",
					id: "value_original",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.value_original ? obj.value_original : "Blank")
				},
				{
					Header: "New",
					id: "value_new",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.value_new)
				},
			];
		}
		else
		{
			columns = [
				{
					Header: "Customer",
					id: "customer",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.customer),
					Cell: (props) => {
						return (
							<span>
								<Link to={`/customers/${props.original.customer}`}>
									{props.original.customer}
								</Link>
							</span>
						);
					}
				},
				{
					Header: "Date Changed",
					id: "modified",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => {
						return obj.modified ? moment(obj.modified).local()
							.format("MM/DD/YYYY hh:mm A") : '-'
					}
				},
				{
					Header: "User",
					id: "modifier",
				},
				{
					Header: "Field",
					id: "field_changed",
				},
				{
					Header: "Original",
					id: "value_original",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.value_original ? obj.value_original : "Blank")
				},
				{
					Header: "New",
					id: "value_new",
					/** @param {Customers_Logs_Object} obj */
					accessor: obj => (obj.value_new)
				},
			];
		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customer Logs')}
							{this.renderHeaderRight("Customer Logs", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
						minRows={0}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
